import React, { Component } from 'react';

import Outlets from './OutletsRoute';

class OutletsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartState: '',
      loaded: false,
      newSelectedOutlet: ''
    };
  }


  async componentDidMount() {

  }



  onChangeOutlet(outlet, toggle = true) {
    let cartState = this.props.cartState;
    cartState.selectedOutlet = outlet;
    cartState.newSelectedOutlet = outlet;
    this.setState({ selectedOutlet: outlet, newSelectedOutlet: outlet, cartState }, () => {
      this.props.updateState(JSON.parse(JSON.stringify(this.state.cartState)));
      //this.checkDeliveryOutletError();
    });
  }

  render() {
    return (
      <>
        <Outlets
          data={this.props.outlets}
          geoLocation={this.props.geoLocation}
          onChangeOutlet={this.onChangeOutlet.bind(this)}
          newSelectedOutlet={this.state.newSelectedOutlet}
        />
      </>
    );
  }
}

export default OutletsList;
